export const settingZoneExplain = parentVue => {
    return {
        description: "<p>Html Pages.</p>"
    };
};



// WEBPACK FOOTER //
// ./src/view/HtmlPages/fields.js